import React from 'react'
import './MapView.css'

export default function MapView() {
  return (
    <div className="map-view-container">
      <iframe
        className="map-view-iframe"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.7992598032147!2d78.15262117477785!3d8.804921191247756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b03ef9fce6bef37%3A0x4bcd31f558260098!2sSt.%20Francis%20Xavier%20Higher%20Secondary%20School!5e0!3m2!1sen!2sin!4v1765003020833!5m2!1sen!2sin"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="St. Francis Xavier School Location"
      ></iframe>
    </div>
  )
}
